import { getFunctions, httpsCallable } from "firebase/functions";

export async function sendNotification(type, data) {
  try {
    const functions = getFunctions();
    const fn = httpsCallable(functions, "sendNotification");
    await fn({ type, ...data });
  } catch(e) {
    console.error("Notification failed:", e.message);
    // Don't throw - notifications are non-critical
  }
}
